<template>
  <aside class="relative w-64 z-10 hidden md:block">
    <div
      ref="sidebar"
      class="fixed w-64 h-screen top-0 left-0 h-full shadow-md bg-transparent"
      style="padding-top: 60px;"
    >
      <div class="bg-secondary h-screen">
        <slot />
      </div>
    </div>
  </aside>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
export default {
  setup() {
    const sidebar = ref();

    const handleScroll = () => {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;

      if (scrollValue < 61) {
        sidebar.value.style.paddingTop = `${61 - scrollValue}px`;
      } else {
        sidebar.value.style.paddingTop = `0px`;
      }
    };

    onMounted(() => {
      document.addEventListener("scroll", handleScroll);
    });

    onUnmounted(() => {
      document.removeEventListener("scroll", handleScroll);
    });

    return {
      sidebar
    };
  }
};
</script>
